<template>
    <div class="creatAccount">
        <h2>Complete Registration</h2>
        <p>{{$store.state.firstName}}, your account {{$store.state.email}}<span>(TVU Networks)</span> has been successfully registered, please enter the following information to finish</p>
        <p class="f14">Your phone number will be used for account security. It won’t be visible to others.</p>
        <div class="form">
            <el-form :model="completeInfo" ref="accountForm" :rules="rule">
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="password"
                            :rules="[{ required: true, message: 'please enter password', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="completeInfo.password"
                                placeholder="Password"
                                :maxlength="32"
                                type="password"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="confirmPassword"
                            :rules="[{ required: true, message: 'please enter confirm password', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="completeInfo.confirmPassword"
                                placeholder="Confirm password"
                                :maxlength="32"
                                type="password"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="phone"
                            :rules="[{ required: true, message: 'please enter phone number', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="completeInfo.phone"
                                placeholder="Phone number"
                                :maxlength="32"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="jobTitle"
                            :rules="[{ required: true, message: 'plase select job role', trigger: 'change' }]"
                        >
                            <el-select placeholder="Job Role" v-model="completeInfo.jobTitle">
                                <el-option
                                    v-for="(item, key) in roleList"
                                    :key="key"
                                    :label="item.code"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="completeInfo.jobTitle == 'Other, please describe'">
                    <el-col :span="24">
                        <el-form-item
                            prop="other"
                            :rules="[{ required: true, message: 'please enter your job role', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="completeInfo.other"
                                placeholder="Enter your Job Role"
                                :maxlength="32"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="btn clearfix">
            <span class="f_l" v-if="backBtn">
                <a @click="back">Back</a>
            </span>
            <el-button class="f_r" @click="validateForm" :disabled="isSendAjax">Done</el-button>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
const sha512 = require("js-sha512").sha512; 
export default {
    props:{
        backBtn: Boolean
    },
    data(){
        return{
            completeInfo:{},
            rule:{},
            roleList:[
                {code:'Producer/Director'},
                {code:'Photographer'},
                {code:'Engineering'},
                {code:'Finance'},
                {code:'Other, please describe'},
            ],
            errorCode: this.$store.state.errorCodeLink,
            isSendAjax:false,
        }
    },
    methods:{
        // 验证项
        validateForm() {
            // this.$emit('showModule',{type:'next',module:'creat',back:'complete'});
            // return;
            let flag = false;
            this.$refs['accountForm'].validate((valid) => {
              flag = valid
            })
            if(!flag) return;
            if(this.completeInfo.password.length < 6){
                this.$message.error('At least 6 digit password');
                return;
            }
            if(this.completeInfo.password != this.completeInfo.confirmPassword){
                this.$message.error('Inconsistent password');
                return;
            }
            if(this.completeInfo.password != this.completeInfo.confirmPassword){
                this.$message.error('Inconsistent password');
                return;
            }

            gaAnalyze('lpCompleteDone');

            let data = JSON.parse(JSON.stringify(this.completeInfo));
            data.jobTitle = data.other ? data.other : data.jobTitle;
            data.password = sha512(data.password).toUpperCase()
            data.confirmPassword = sha512(data.confirmPassword).toUpperCase()
            delete data.other;
            if(flag){
                if(this.isSendAjax) return;
                this.isSendAjax = true;
                data.userId = this.$store.state.userId;
                data.service = 1;
                this.axios.post('/userGroup/user-group/rgUser/complete',data)
                .then(res => {
                    this.isSendAjax = false;
                    if(res.status == 200){
                        let linkName = this.errorCode[res.data.errorCode];
                        if(linkName){
                            this.$emit('showModule',{type:'next',module:linkName,back:'complete'});
                        }else{
                            if(res.data.errorCode == '0x0'){
                                this.$message.success(res.data.errorInfo);
                                let key = res.data.result;
                                window.location.href = "http://" + window.location.host + '/userGroup/user-group/rgUser/redirectSuccess?service=1&userId=' + this.$store.state.userId + '&key=' + key;
                                // window.location.href = 'http://10.12.22.101/userGroup/user-group/rgUser/redirectSuccess?service=1&userId=' + this.$store.state.userId + '&key=' + key;
                            }else{
                                this.$message.error(res.data.errorInfo);
                            }
                        }
                    }
                })
            }
        },
        back(){
            gaAnalyze('lpCompleteBack');
            this.$emit('showModule',{type:'back'})
        }
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    
    font-size: .16rem;
    span{
        font-weight: bold;
    }
    margin-bottom: .1rem;
    &.f14{
        color: #999;
        font-size: .14rem;
        margin-bottom: 0.35rem;

    }
}
.is-disabled{
    background: #6BCB82 !important;
}
.btn{
    position: relative;
    a{
        color: #1EC345;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
}
/deep/.el-select{
    display: block;
}
@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.10rem;
        &.f14{
            margin-bottom: .13rem;
        }
    }
    .creatAccount{
        max-height: 460vh;
        overflow-y: auto;
        margin-top: -0.2rem;
    }
    /deep/.el-form-item{
        margin-bottom: .18rem !important;
    }
}
</style>

